/**
 * Created by andrey on 01.08.2022
 */

HideAnimations = function (f) {
    const game = Game.currentGame;

    const actions = [
        game.clearTable.bind(game),

        function (f) {
            game.hand.hideExtra();
            f();
        }
    ];

    new ActionPlayer(actions).play(f);
};